import { InfoIconButton } from "src/components/InfoIconButton";
import { toFormattedInteger } from "src/utils";

export default ({ amount, title, iconHandler }: LoanOverviewItemProp) => {
  return (
    <>
      <div className="mb-[5px] flex items-center text-center text-base leading-6 font-medium text-[#111827]">
        {title}
        <InfoIconButton marginLeft="8px" onClick={iconHandler} tabIndex={0} />
      </div>
      <div className="text-2xl leading-6 font-bold text-[#00b27c]">
        ${toFormattedInteger(amount)}
      </div>
    </>
  );
};

type LoanOverviewItemProp = {
  title: string;
  amount: string | undefined;
  iconHandler: () => void;
};
